<template>
  <div class="app-side app-side-menu">
    <div class="app-side-scroll">
      <div class="app-logo" :style="sidebar.opened ? 'padding: 0 40px;' : 'padding: 0 20px;'">
        <span>首开社区垃圾分类后台管理系统</span>
      </div>
      <ul class="app-nav app-nav-tree">
        <li :class="{'app-nav-item': true, 'app-nav-itemed': item.name === openModuleName}" v-if="item.children && item.children.length > 0" v-for="(item, index) in filteredChildren" :key="index" @click="clickMoudleList(item)">

          <a v-if="sidebar.opened" href="javascript:;" >
            <i class="app-icon el-icon-folder"></i>
            <span>
                <el-badge is-dot class="item" :hidden="isItemDot(item)">{{item.meta.title}}</el-badge>
              </span>
            <i class="el-icon-arrow-down" style="position: absolute;right: 20px;"></i>
          </a>
          <el-tooltip v-else class="item" effect="dark" :content="item.meta.title" placement="right" style="padding-right: 0;">
            <a href="javascript:;" @click="onClickLeftMenu" >
              <i class="app-icon el-icon-folder"></i>
            </a>
          </el-tooltip>
          <dl class="app-nav-child">
            <template v-if="item.isStatic">
              <dd v-for="(menuItem, index) in filterMenuItems(item.children)" :hidden="isRoleExist(menuItem)" :key="index">
                <router-link :to="{ name: menuItem.name }" :key="menuItem.name" :class="{'current-highlight': menuItem.name == currentMenuName}">
                  <el-badge v-if="messageMap[menuItem.name] && parseInt(messageMap[menuItem.name]) > 0" :value="messageMap[menuItem.name]" class="item">
                    {{menuItem.meta.title}}
                  </el-badge>
                  <template v-else>
                    {{menuItem.meta.title}}
                  </template>
                </router-link>
              </dd>
            </template>
            <template v-else >
              <dd v-for="menuItem in filterMenuItems(moduleMap[item.moduleId] || [])" >
                <router-link :to="{ name: menuItem.name }" :key="menuItem.name" :class="{'current-highlight': menuItem.name == currentMenuName}">
                  <el-badge v-if="messageMap[menuItem.name] && parseInt(messageMap[menuItem.name]) > 0" :value="messageMap[menuItem.name]" class="item">
                    {{menuItem.meta.title}}
                  </el-badge>
                  <template v-else>
                    {{menuItem.meta.title}}
                  </template>
                </router-link>
              </dd>
            </template>
          </dl>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
export default {
  name: 'WtSide',
  data() {
    return {
      currentMenuName: '',
      openModuleName: ''
    }
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch('ToggleSideBar')
    },
    // 根据当前系统过滤菜单项
    filterMenuItems(items) {
      if (!items || items.length === 0) {
        return []
      }
      return items.filter(item => {
        // 如果没有 systemCode，默认显示（回收管家）
        if (!item.meta || !item.meta.systemCode) {
          return this.currentSystem === 'systemA'
        }
        // 根据当前系统过滤
        return item.meta.systemCode === this.currentSystem
      })
    },
    isItemDot(item) {
      const that = this
      let isDotHidden = true
      if (item.isStatic && item.children) {
        item.children.forEach((menuItem) => {
          if (that.messageMap[menuItem.name] && parseInt(that.messageMap[menuItem.name]) > 0) {
            isDotHidden = false
          }
        })
      } else if (!item.isStatic && that.moduleMap[item.moduleId]) {
        that.moduleMap[item.moduleId].forEach((menuItem) => {
          if (that.messageMap[menuItem.name] && parseInt(that.messageMap[menuItem.name]) > 0) {
            isDotHidden = false
          }
        })
      }
      return isDotHidden
    },
    isRoleExist(item) {
      let isExistHidden = true
      if (!item.meta.roleType) {
        isExistHidden = false
      }
      if (item.meta.roleType && this.setRoleList.indexOf(item.meta.roleType) > -1) {
        isExistHidden = false
      }
      return isExistHidden
    },
    onClickLeftMenu() {
      this.$store.dispatch('ToggleSideBar')
    },
    clickMoudleList(item) {
      if (item.name === this.openModuleName) {
        this.openModuleName = ''
      } else {
        this.openModuleName = item.name
      }
    }
  },
  watch: {
    $route(to, from, val) {
      this.openModuleName = to.name
      this.currentMenuName = to.name
    }
  },
  computed: {
    ...mapState({
      messageMap: state => state.auth.messageMap,
      moduleItem: state => state.auth.moduleItem,
      moduleMap: state => state.auth.moduleMap,
      setRoleList: state => state.auth.setRoleList
    }),
    ...mapGetters([
      'sidebar',
      'currentSystem'
    ]),
    // 过滤后的子菜单
    filteredChildren() {
      if (!this.moduleItem.children || this.moduleItem.children.length === 0) {
        return []
      }
      return this.moduleItem.children.filter(item => {
        // 检查父菜单下是否有属于当前系统的子菜单
        const childItems = item.isStatic ? (item.children || []) : (this.moduleMap[item.moduleId] || [])
        const hasValidChild = childItems.some(child => {
          if (!child.meta || !child.meta.systemCode) {
            // 没有systemCode的子菜单只在回收管家显示
            return this.currentSystem === 'systemA'
          }
          // 有systemCode的子菜单根据systemCode判断
          return child.meta.systemCode === this.currentSystem
        })

        // 只有当父菜单下有属于当前系统的子菜单时，才显示父菜单
        return hasValidChild
      })
    }
  }
}
</script>
